import React from 'react';
import {AsyncPaginate} from 'react-select-async-paginate';
import {t} from 'react-switch-lang';
import './SelectSearchMulti.scss';
import axios from 'axios';

const SelectSearchMulti = React.forwardRef(
  (
    {
      name,
      className,
      placeholder,
      isMulti,
      value,
      api,
      onChange,
      optionValue,
      optionLabel,
      isSearchable = false,
      searchParams,
        isClearable=false
    },
    ref
  ) => {
    const optionVal = optionValue !== undefined ? optionValue : 'id';
    const optionLab = optionLabel !== undefined ? optionLabel : 'name';

    const loadOptions = async (search, previous, {page, pageSize}) => {
      let filteredOptions = [];
      let hasMore = true;

      const formatOptions = (options) => {
        return {
          options: options.map((option) => ({
            value: option[optionVal],
            label: option[optionLab],
          })),
          hasMore: hasMore,
          additional: {
            page: page + 1,
            pageSize,
          },
        };
      };

      if (!search) {
        try {
          const {data} = await axios.get(`${api}`);
          filteredOptions = data;
          hasMore = false;
        } catch (e) {
          hasMore = false;
          // console.log(e);
        }
        return formatOptions(filteredOptions);
      }

      if (search.length < 1) {
        return {options: filteredOptions, hasMore: false};
      }

      try {
        let searchQuery = '';
        searchParams !== undefined &&
          searchParams.map((item) => {
            searchQuery += `&${item}=${search}`;
          });
        const {data} = await axios.get(
          `${api}&page=${page}&size=${pageSize}${searchQuery}`
        );
        filteredOptions = data;
        hasMore = data > 0;
      } catch (e) {
        hasMore = false;
        // console.log(e);
      }
      return formatOptions(filteredOptions);
    };

    return (
      <AsyncPaginate
        defaultOptions
        id={name}
        name={name}
        placeholder={placeholder}
        className={className}
        onChange={onChange}
        value={value}
        isMulti={isMulti}
        loadOptions={loadOptions}
        noOptionsMessage={() => t('table.no-data')}
        loadingMessage={() => t('message.loading')}
        debounceTimeout={300}
        additional={{page: 0, pageSize: 20}}
        closeMenuOnSelect={!isMulti}
        selectRef={ref}
        isClearable={isClearable}
        isSearchable={isSearchable}
      />
    );
  }
);

export default SelectSearchMulti;